/**
 * Tracks in-flight browser `apiFetch` calls for a global loading overlay.
 * No-op on the server (`window` undefined).
 */

type Listener = (inFlight: number) => void;

let inFlight = 0;
const listeners = new Set<Listener>();

function notify(): void {
  for (const l of listeners) {
    l(inFlight);
  }
}

export function subscribeApiLoading(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function beginApiLoading(): void {
  if (typeof window === "undefined") {
    return;
  }
  inFlight += 1;
  notify();
}

export function endApiLoading(): void {
  if (typeof window === "undefined") {
    return;
  }
  inFlight = Math.max(0, inFlight - 1);
  notify();
}

/** Clears counter and notifies (for tests). */
export function resetApiLoadingForTests(): void {
  inFlight = 0;
  notify();
}
